import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-form-dialog-wrapper',
  templateUrl: './payment-form-dialog-wrapper.component.html',
  styleUrls: ['./payment-form-dialog-wrapper.component.css']
})
export class PaymentFormDialogWrapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
